import { render, staticRenderFns } from "./leaderBoard.vue?vue&type=template&id=00f0e276&scoped=true&lang=pug"
import script from "./leaderBoard.vue?vue&type=script&lang=ts"
export * from "./leaderBoard.vue?vue&type=script&lang=ts"
import style0 from "./leaderBoard.vue?vue&type=style&index=0&id=00f0e276&prod&lang=stylus&scoped=true"
import style1 from "./leaderBoard.vue?vue&type=style&index=1&id=00f0e276&prod&lang=stylus&scoped=true"
import style2 from "./leaderBoard.vue?vue&type=style&index=2&id=00f0e276&prod&lang=stylus&scoped=true"
import style3 from "./leaderBoard.vue?vue&type=style&index=3&id=00f0e276&prod&lang=stylus&scoped=true"
import style4 from "./leaderBoard.vue?vue&type=style&index=4&id=00f0e276&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f0e276",
  null
  
)

export default component.exports